import { render, staticRenderFns } from "./CardBacklog.vue?vue&type=template&id=80faae52&scoped=true&"
import script from "./CardBacklog.vue?vue&type=script&lang=js&"
export * from "./CardBacklog.vue?vue&type=script&lang=js&"
import style0 from "./CardBacklog.vue?vue&type=style&index=0&id=80faae52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80faae52",
  null
  
)

export default component.exports